import {
  getSupplierList,
} from '@/api/goods-service/index';
import { ref } from 'vue';
import { IGetSupplierListRes } from '@/api/goods-service/type.d';
import { debounce } from 'lodash-es';

export default function useSupplierList() {
  const supplierList = ref<IGetSupplierListRes['list']>([]);
  const supplierLoading = ref(false);
  const supplierParamsKey = ref<'supplierName' | 'supplierCode'>('supplierName');
  const supplierParamsList = [
    { label: '供应商名称', value: 'supplierName' },
    { label: '供应商编码', value: 'supplierCode' },
  ];
  const getSupplierListByQuery = debounce(async (val: string) => {
    try {
      if (supplierLoading.value === true || val === '') {
        return;
      }
      supplierLoading.value = true;
      const { data: {
        list,
      } } = await getSupplierList({
        pageNum: 1,
        pageSize: 100,
        supplierCategory: 'INGREDIENT_SUPPLIER',
        [supplierParamsKey.value]: val,
      });
      supplierLoading.value = false;
      supplierList.value = list;
      console.log(list);
    } catch (error) {
      console.log('获取列表失败', error);
    }
  }, 300);
  return {
    supplierParamsList,
    supplierParamsKey,
    getSupplierListByQuery,
    supplierList,
    supplierLoading,
  };
}
